import { __assign } from '../../../../../../../../node_modules/tslib/tslib.es6.js';
import ZigDropdown from '../../../../display/ZigDropdown/index.js';
import React__default, { useMemo } from 'react';
import { DropdownItem } from '../../styles.js';
import { useLongestString } from '../util.js';
import { DropdownLabel } from '../atoms/DropdownLabel/index.js';
import MobileFilterButton from '../atoms/MobileFilterButton/index.js';

var SelectFilterDropdown = function (_a) {
    var filter = _a.filter, onChange = _a.onChange, mobile = _a.mobile, resetFilter = _a.resetFilter, prefixId = _a.prefixId;
    var displayValue = useMemo(function () {
        var _a;
        var option = filter.options.find(function (option) { return option.value === filter.value; });
        return (_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : "";
    }, [filter.value, filter.options]);
    var longestWidth = useLongestString(filter.options.map(function (o) { return o.label; }));
    if (mobile) {
        return (React__default.createElement(MobileFilterButton, { filter: filter, onChange: onChange, resetFilter: resetFilter, label: displayValue, prefixId: prefixId }));
    }
    return (React__default.createElement(ZigDropdown, { id: "".concat(prefixId, "__select-").concat(filter.id), component: function (_a) {
            var open = _a.open;
            return (React__default.createElement(DropdownItem, { active: open },
                React__default.createElement(DropdownLabel, { minSpace: longestWidth, label: filter.label, value: displayValue })));
        }, options: filter.options.map(function (option, index) { return ({
            active: filter.value === option.value,
            onClick: function () { return onChange(__assign(__assign({}, filter), { value: option.value })); },
            id: "select-filter__option-".concat(index),
            label: option.label,
        }); }) }));
};

export { SelectFilterDropdown as default };
